export default {
  data() {
    return {
      isMobileDisplay: false,
      mediaMatch: null,
    };
  },
  methods: {
    handler(e) {
      this.isMobileDisplay = e.matches;
    },
  },
  props: {
    size: {
      type: Number,
      default: 1024,
      required: true,
    },
  },
  mounted() {
    if (this.mediaMatch === null) {
      this.mediaMatch = window.matchMedia(`(max-width: ${this.size}px)`);
      this.isMobileDisplay = this.mediaMatch.matches;
    } else {
      this.mediaMatch.addListener(this.handler);
    }
  },
};
